import axios from 'axios';
import { AuthResponse } from "../models/response/AuthResponse";
const cfg = require("../config.json");

export const API_URL = cfg.backendURL + '/api';

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL,
});

// Добавляем токен в каждый запрос
$api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Блокировка и очередь для рефреша
let isRefreshing = false;
let failedQueue: {
    resolve: (value?: any) => void,
    reject: (reason?: any) => void
}[] = [];

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

$api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._isRetry) {
            originalRequest._isRetry = true;

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({
                        resolve: (token: string) => {
                            if (originalRequest.headers)
                                originalRequest.headers.Authorization = `Bearer ${token}`;
                            resolve($api(originalRequest));
                        },
                        reject
                    });
                });
            }

            isRefreshing = true;

            try {
                const response = await axios.get<AuthResponse>(`${API_URL}/refresh`, {
                    withCredentials: true,
                });

                const newToken = response.data.accessToken;
                localStorage.setItem('token', newToken);

                processQueue(null, newToken);

                // Обновляем заголовок и повторяем исходный запрос
                if (originalRequest.headers)
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;

                return $api(originalRequest);
            } catch (err) {
                processQueue(err, null);
                console.log('Not Authorized');
                throw err;
            } finally {
                isRefreshing = false;
            }
        }

        throw error;
    }
);

export default $api;